<h3>Unauthorized</h3>
<div *ngIf="error$ | async as error; else default">
  <p *ngIf="error === 'noRolesGranted'">
    You do not have any roles granted, please reach out to Comm supervisor for access.
  </p>
  <p *ngIf="error === 'tcsAccessDenied'">
    You do not have access or email address does not exist. Contact Comm Supervisor for permission.
  </p>
</div>
<ng-template #default>
  <p>The current user does not have access to the requested resource.</p>
</ng-template>
